<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHandleSlave from "../DesignerQuestionHardwareHandleSlave.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHandleSlave
        ],
        computed: {
            panel_required(){
                return this.filtered_option_list.length > 1;
            },
            extra_text: {
              default() {
                return '';
              }
            },
        },
    }
</script>
